import { render, staticRenderFns } from "./ovningsblad.vue?vue&type=template&id=bbd8a4ae&scoped=true"
import script from "./ovningsblad.vue?vue&type=script&lang=js"
export * from "./ovningsblad.vue?vue&type=script&lang=js"
import style0 from "./ovningsblad.vue?vue&type=style&index=0&id=bbd8a4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd8a4ae",
  null
  
)

export default component.exports